/**
 * Centralized configuration for all links in the application
 * Pre-launch configuration - minimal external links only
 */

export const links = {
  // Brand and domain (will be updated when domain is finalized)
  brand: {
    name: 'examr',
    domain: 'examr.ai', // Placeholder - will be updated with actual Vercel domain
    fullDomain: 'https://examr.ai', // Placeholder - will be updated
  },

  // External URLs - minimal for pre-launch
  external: {
    // Support and feedback
    whatsappGroup: 'https://chat.whatsapp.com/LVG9s6TMXRF7jDhngSZc7l',
    
    // Email addresses
    supportEmail: 'feedback@zenmathmind.com',
    secondaryEmail: 'michael@themathologists.com.au',
  },

  // Internal application routes
  internal: {
    // Public pages
    home: '/',
    login: '/login',
    register: '/register',
    forgotPassword: '/forgot-password',
    resetPassword: '/reset-password',
    verifyEmail: '/verify-email',
    resendVerification: '/resend-verification',
    privacy: '/privacy',
    contact: '/contact',
    educators: '/educators',
    business: '/business',
    
    // Authenticated pages
    dashboard: '/dashboard',
    documents: '/documents',
    segments: '/segments',
    generate: '/generate',
    generateV2: '/generate-v2',
    completeReview: '/complete-review',
    completeReviewList: '/complete-review-list',
    courseManagement: '/course-management',
    firstLogin: '/first-login',
    subscriptionPlans: '/subscription/plans',
    subscriptionSuccess: '/subscription/success',
    
    // Demo pages
    demoExam: '/demo/exam',
    demoQuiz: '/demo/quiz',
    
    // Referral
    referralLanding: '/join/alpha',
  },

  // API endpoints (for reference)
  api: {
    baseUrl: process.env.REACT_APP_API_URL || 'http://localhost:8001',
    demoImages: '/api/demo/images',
  },

  // Email templates
  emailTemplates: {
    feedback: {
      getMailtoLink: (username = 'User', subject = 'Feedback', body = '') => {
        const params = new URLSearchParams({
          cc: links.external.secondaryEmail,
          subject: subject || `Feedback from ${username}`,
          body: body,
        });
        return `mailto:${links.external.supportEmail}?${params.toString()}`;
      },
    },
    
    referral: {
      getEmailSubject: () => `You're invited to join examr's exclusive alpha program`,
      getEmailBody: (referralUrl) => `Hi there!

I've been selected to participate in examr's exclusive alpha testing program, and I have a limited number of invitations to share.

examr is an AI-powered exam generation platform that's revolutionizing how educators create and manage assessments. As an alpha tester, you'll get early access to cutting-edge features and help shape the future of educational technology.

Join me in the alpha program: ${referralUrl}

This invitation won't last long, so grab your spot!

Best regards`,
      
      getWhatsAppMessage: (referralUrl) => `🎉 I've got an exclusive invite for you!

I'm part of examr's alpha testing program - an AI-powered exam generator that's changing education.

You can join too with my personal invite: ${referralUrl}

Limited spots available! 🚀`,
    },
  },

  // Dynamic link generators
  getDemoUrl: (examId, isQuiz = false) => {
    const baseUrl = isQuiz ? links.internal.demoQuiz : links.internal.demoExam;
    return `${baseUrl}/${examId}`;
  },

  getReferralUrl: (referralToken) => {
    return `${links.internal.referralLanding}/${referralToken}`;
  },

  getSegmentsUrl: (documentId) => {
    return `${links.internal.segments}/${documentId}`;
  },

  getCompleteReviewUrl: (documentId) => {
    return documentId 
      ? `${links.internal.completeReview}/${documentId}`
      : links.internal.completeReviewList;
  },
};

// Freeze the object to prevent accidental modifications
Object.freeze(links);
Object.freeze(links.external);
Object.freeze(links.internal);
Object.freeze(links.api);

export default links;